"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _ReportPrivateMessageModal = _interopRequireDefault(require("./ReportPrivateMessageModal"));

var _PrivateMessageReportedModal = _interopRequireDefault(require("./PrivateMessageReportedModal"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _privateMessageService = require("../../../services/privateMessageService");

var _translations = require("../../../libs/translationsUtils/translations");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ReportPrivateMessage = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ReportPrivateMessage, _PureComponent);

  var _super = _createSuper(ReportPrivateMessage);

  function ReportPrivateMessage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ReportPrivateMessage);
    _this = _super.call(this, props);
    _this.state = {
      showReportSuccessModal: false,
      reason: ''
    };
    _this.handleReasonChanged = _this.handleReasonChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleReportThisMessage = _this.handleReportThisMessage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ReportPrivateMessage, [{
    key: "handleReasonChanged",
    value: function handleReasonChanged(reason) {
      this.setState({
        reason: reason
      });
    }
  }, {
    key: "handleReportThisMessage",
    value: function () {
      var _handleReportThisMessage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var messageId, reason;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                messageId = this.props.messageId;
                reason = this.state.reason;

                if (!(reason.length < 3)) {
                  _context.next = 5;
                  break;
                }

                this.setState({
                  errorMessage: (0, _translations.t)('Forum', 'privateMessages.reportModal.reasons.error')
                });
                return _context.abrupt("return");

              case 5:
                _context.prev = 5;
                _context.next = 8;
                return (0, _privateMessageService.reportPrivateMessage)(messageId, reason);

              case 8:
                this.setState({
                  showReportSuccessModal: true
                });
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](5);
                this.props.hideReportModal();
                this.props.setAlertMessage((0, _preact.h)(_phrase.default, {
                  p: "privateMessages.reportModal.error"
                }));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function handleReportThisMessage() {
        return _handleReportThisMessage.apply(this, arguments);
      }

      return handleReportThisMessage;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          conversationUser = _this$props.conversationUser,
          messageContent = _this$props.messageContent,
          hideReportModal = _this$props.hideReportModal;
      var _this$state = this.state,
          showReportSuccessModal = _this$state.showReportSuccessModal,
          reason = _this$state.reason,
          errorMessage = _this$state.errorMessage;
      return (0, _preact.h)("div", null, showReportSuccessModal ? (0, _preact.h)(_PrivateMessageReportedModal.default, {
        onIUnderstand: hideReportModal
      }) : (0, _preact.h)(_ReportPrivateMessageModal.default, {
        senderUsername: conversationUser.username,
        reportedMessage: messageContent,
        reason: reason,
        onReasonChanged: this.handleReasonChanged,
        onReport: this.handleReportThisMessage,
        onCancel: hideReportModal,
        errorMessage: errorMessage
      }));
    }
  }]);
  return ReportPrivateMessage;
}(_preactCompat.PureComponent);

var _default = ReportPrivateMessage;
exports.default = _default;